import { useMemo } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { getQueryData } from '../../../api/helpers'
import { DocumentFile } from '../../../api/documents/types'
import { RouteParams } from '../../../api/globalTypes'
import { documentsInputs } from '../../../common/forms/documents/inputs'
import { documentValidation } from '../../../common/forms/documents/validations'
import { useEntityParams } from '../../AppPermissionsSwitcher/EntityParamsContext'

// DocumentFile: edit mode, the real document;
// { module }: create mode (module known when scoped, undefined on the unscoped list);
// undefined: edit mode only, when the document prop isn't supplied
type DocumentFormConfigData = DocumentFile | { module?: string } | undefined

interface EntityQueryData {
    item?: { internalAppId?: number }
}

export const useDocumentFormConfig = (data: DocumentFormConfigData, disableIdFields = false) => {
    const { id } = useParams<RouteParams>()
    const { pathname } = useLocation()
    // params the view's GetEntity query was called with, needed to match its cache key
    const entityParams = useEntityParams()

    const module = pathname.split('/')[1]
    const entityData = getQueryData<EntityQueryData>([module, id], entityParams)
    const parentInternalAppId = entityData?.item?.internalAppId

    const updatedData = useMemo(() => ({ ...data, parentInternalAppId: parentInternalAppId ?? null }), [data, parentInternalAppId])
    const isEdit = Boolean(data && 'id' in data && data.id)

    const documentInputs = useMemo(() => documentsInputs(isEdit, disableIdFields), [isEdit, disableIdFields])
    const documentValidationConfig = useMemo(() => documentValidation(updatedData), [updatedData])

    return { documentInputs, documentValidationConfig }
}
